import * as React from "react";
const SvgFiRrFaceAnxiousSweat = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-face-anxious-sweat_svg__a)">
      <path
        fill="#062147"
        d="M24 12c0 6.617-5.383 12-12 12a11.95 11.95 0 0 1-8.236-3.272 1.001 1.001 0 0 1 1.373-1.455A9.96 9.96 0 0 0 12 22.001c5.514 0 10-4.486 10-10S17.514 2 12 2a9.97 9.97 0 0 0-8.91 5.455 1.001 1.001 0 0 1-1.782-.91A11.96 11.96 0 0 1 12 0c6.617 0 12 5.383 12 12m-6.274-3.038q.138.038.275.038a1 1 0 0 0 .274-1.962c-.965-.275-1.977-.941-2.46-1.619a1 1 0 1 0-1.628 1.163c.746 1.045 2.135 1.979 3.54 2.381zm-9.54-3.543c-.484.678-1.496 1.344-2.46 1.619a1 1 0 0 0 .549 1.924c1.404-.401 2.793-1.336 3.54-2.381a1 1 0 0 0-1.628-1.163zM8.5 11a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 8.5 11m7 3a1.5 1.5 0 1 0-.001-3.001A1.5 1.5 0 0 0 15.5 14m-7.463 3.96c-.178.51.224 1.04.765 1.04h6.384c.538 0 .941-.524.768-1.033-.487-1.432-2.04-2.966-3.954-2.966s-3.463 1.531-3.963 2.96zM5 14.5c0-1.403-1.184-3.372-1.922-4.235a.754.754 0 0 0-1.151.004C1.189 11.143 0 13.13 0 14.5a2.5 2.5 0 1 0 5 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-face-anxious-sweat_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFaceAnxiousSweat;
